import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Pagination = ({
  tableManager,
  page = tableManager.paginationApi.page,
  onChange = tableManager.paginationApi.setPage
}) => {
  const {
    config: {
      texts: {
        prev: prevText,
        page: pageText,
        next: nextText,
        of: ofText
      },
      additionalProps: {
        pagination: additionalProps = {}
      }
    },
    paginationApi: {
      totalPages
    }
  } = tableManager;
  let backButtonDisabled = page - 1 < 1;
  let nextButtonDisabled = page + 1 > totalPages;
  let classNames = ('rgt-footer-pagination ' + (additionalProps.className || '')).trim();
  return /*#__PURE__*/_jsxs("div", { ...additionalProps,
    className: classNames,
    children: [/*#__PURE__*/_jsx("button", {
      className: `rgt-footer-pagination-button${backButtonDisabled ? ' rgt-disabled-button' : ''}`,
      disabled: page - 1 < 1,
      onClick: () => onChange(page - 1),
      children: prevText
    }), /*#__PURE__*/_jsxs("div", {
      className: "rgt-footer-pagination-input-container",
      children: [/*#__PURE__*/_jsxs("span", {
        children: [pageText, " "]
      }), /*#__PURE__*/_jsx("input", {
        onClick: event => event.target.select(),
        className: "rgt-footer-page-input",
        type: "number",
        value: totalPages ? page : 0,
        onChange: event => onChange(event.target.value * 1)
      }), /*#__PURE__*/_jsxs("span", {
        children: [ofText, " ", totalPages]
      })]
    }), /*#__PURE__*/_jsx("button", {
      className: `rgt-footer-pagination-button${nextButtonDisabled ? ' rgt-disabled-button' : ''}`,
      disabled: page + 1 > totalPages,
      onClick: () => onChange(page + 1),
      children: nextText
    })]
  });
};

export default Pagination;